export const SelectStyles = {
  container: (provided) => ({
    ...provided,
    width: '100%',
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: 0,
    borderWidth: '0 0 2px 0',
    borderColor: 'var(--backgroundPrimario)',
    borderStyle: 'solid',
    cursor: 'pointer',
    boxShadow: 'none',
    '&>div:first-of-type,&>div:first-of-type div': {
      marginLeft: 0,
      paddingLeft: 0,
    },
    '&:hover': {
      borderColor: 'var(--backgroundPrimario)',
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    svg: {
      fill: 'var(--backgroundPrimario)',
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    svg: {
      fill: 'var(--backgroundPrimario)',
    },
  }),
};
